import { JOB_QUESTION_TYPES } from '@/store';
import { VISA_STATUSES_LABELS } from '@/store';
import { ETHNICITY_LABELS } from '@/store';
import { GENDER_LABELS } from '@/store';


export const JOB_OFFER_CRITERIA = [
  {
    id: `${Date.now()}ss`,
    member_preamble: null,
    talent_preamble: null,
    member_prompt: null,
    talent_prompt: null,
    member_explanation: null,
    talent_explanation: null,
    label: 'Specialty/Subspecialty',
    type: JOB_QUESTION_TYPES.SPECIALTY,
    talent_type: JOB_QUESTION_TYPES.SPECIALTY,
    required: true,
    is_active: 1,
    value: null,
  },
  {
    id: `${Date.now()}ji`,
    member_preamble: null,
    talent_preamble: null,
    member_prompt: null,
    talent_prompt: null,
    member_explanation: null,
    talent_explanation: null,
    label: 'Job Opportunity Information',
    type: JOB_QUESTION_TYPES.JOB_INFORMATION,
    talent_type: JOB_QUESTION_TYPES.JOB_INFORMATION,
    required: true,
    is_active: 1,
    value: null,
  },
];

const visaStatusVariables = [];

let order = 1;
for (let type in VISA_STATUSES_LABELS) {
  visaStatusVariables.push({
    dv_name: null,
    id: type,
    input_label: VISA_STATUSES_LABELS[type],
    is_exclusive_member: 0,
    is_exclusive_talent: 0,
    is_talent_hidden: 0,
    job_question_id: `${Date.now()}vs`,
    max: null,
    max_label: null,
    min: null,
    min_label: null,
    order: order,
    prefix: null,
    short_label: null,
    singular_suffix: null,
    step: null,
    suffix: null,
    variableOptions: [],
  });
  order++;
}

export const JOB_TERMS = [
  {
    id: `${Date.now()}bc`,
    member_preamble: null,
    talent_preamble: null,
    member_prompt: null,
    talent_prompt: null,
    member_explanation: null,
    talent_explanation: null,
    label: 'Board Certification',
    type: JOB_QUESTION_TYPES.BOARD_CERTIFICATION,
    talent_type: JOB_QUESTION_TYPES.BOARD_CERTIFICATION,
    required: true,
    is_active: 1,
    value: null,
    jobQuestionVariables: [
      {
        dv_name: null,
        id: 0,
        input_label: 'Board Certification',
        is_exclusive_member: 0,
        is_exclusive_talent: 0,
        is_talent_hidden: 0,
        job_question_id: `${Date.now()}bc`,
        max: null,
        max_label: null,
        min: null,
        min_label: null,
        order: 1,
        prefix: null,
        short_label: null,
        singular_suffix: null,
        step: null,
        suffix: null,
        variableOptions: [],
      },
    ],
  },
  {
    id: `${Date.now()}vs`,
    member_preamble: null,
    talent_preamble: null,
    member_prompt: null,
    talent_prompt: null,
    member_explanation: null,
    talent_explanation: null,
    label: 'Visa Status',
    type: JOB_QUESTION_TYPES.VISA_STATUS,
    talent_type: JOB_QUESTION_TYPES.VISA_STATUS,
    required: true,
    is_active: 1,
    value: null,
    jobQuestionVariables: visaStatusVariables,
  },
];


const GenderVariables = [];
const EthnicityVariables = [];

for (let type in GENDER_LABELS) {
  GenderVariables.push({
    dv_name: null,
    id: type,
    input_label: GENDER_LABELS[type],
    is_exclusive_member: 0,
    is_exclusive_talent: 0,
    is_talent_hidden: 0,
    job_question_id: `${Date.now()}gen`,
    max: null,
    max_label: null,
    min: null,
    min_label: null,
    order: 1,
    prefix: null,
    short_label: null,
    singular_suffix: null,
    step: null,
    suffix: null,
    variableOptions: [],
  });
}

for (let type in ETHNICITY_LABELS) {
  EthnicityVariables.push({
    dv_name: null,
    id: type,
    input_label: ETHNICITY_LABELS[type],
    is_exclusive_member: 0,
    is_exclusive_talent: 0,
    is_talent_hidden: 0,
    job_question_id: `${Date.now()}et`,
    max: null,
    max_label: null,
    min: null,
    min_label: null,
    order: 1,
    prefix: null,
    short_label: null,
    singular_suffix: null,
    step: null,
    suffix: null,
    variableOptions: [],
  });
}

export const JOB_OTHER_CRITERIA = [
  {
    id: `${Date.now()}ge`,
    member_preamble: null,
    talent_preamble: null,
    member_prompt: null,
    talent_prompt: null,
    member_explanation: null,
    talent_explanation: null,
    label: 'Gender',
    type: JOB_QUESTION_TYPES.GENDER,
    talent_type: JOB_QUESTION_TYPES.GENDER,
    required: false,
    is_active: 1,
    value: null,
    jobQuestionVariables: GenderVariables,
  },
  {
    id: `${Date.now()}et`,
    member_preamble: null,
    talent_preamble: null,
    member_prompt: null,
    talent_prompt: null,
    member_explanation: null,
    talent_explanation: null,
    label: 'Race / Ethnicity',
    type: JOB_QUESTION_TYPES.ETHNICITY,
    talent_type: JOB_QUESTION_TYPES.ETHNICITY,
    required: false,
    is_active: 1,
    value: null,
    jobQuestionVariables: EthnicityVariables,
  },
];

export const JobInformationCriteria = [
  {
    id: `${Date.now()}ji`,
    member_preamble: null,
    talent_preamble: null,
    member_prompt: null,
    talent_prompt: null,
    member_explanation: null,
    talent_explanation: null,
    label: 'Job Opportunity Information',
    type: JOB_QUESTION_TYPES.JOB_INFORMATION,
    talent_type: JOB_QUESTION_TYPES.JOB_INFORMATION,
    required: true,
    is_active: 1,
    value: null,
  }
];

export const getJobOfferJobQuestionResponseValue = (
  jobQuestion,
  jobOfferJobQuestionResponse
) => {
  const responses = [];
  switch (jobQuestion.type) {
    case JOB_QUESTION_TYPES.SELECT_ANY:
    case JOB_QUESTION_TYPES.SELECT_ONE:
      return (jobQuestion.jobQuestionVariables || []).reduce(
        (acc, variable) => {
          if (parseInt(jobOfferJobQuestionResponse[variable.id]) === 1) {
            acc.push(variable.short_label || variable.input_label);
          }
          return acc;
        },
        responses
      );
    case JOB_QUESTION_TYPES.SLIDER: {
      const nf = new Intl.NumberFormat('en-US');
      return (jobQuestion.jobQuestionVariables || []).reduce(
        (acc, variable) => {
          if (
            !jobOfferJobQuestionResponse[variable.id] ||
            !Array.isArray(jobOfferJobQuestionResponse[variable.id])
          ) {
            return acc;
          }
          const minValue = jobOfferJobQuestionResponse[variable.id][0] || null;
          const maxValue = jobOfferJobQuestionResponse[variable.id][1] || null;
          if (minValue === null && maxValue === null) {
            return acc;
          }
          //const minFormatted = nf.format(minValue);
          const maxFormatted = nf.format(maxValue);
          // const minPart = !minValue
          //   ? ``
          //   : `${variable.prefix || ''}${minFormatted}${
          //       variable.suffix || ''
          //     } - `;
          // acc.push(
          //   `<div class="d-flex">
          //       <div>
          //          ${minPart}${variable.prefix || ''}${maxFormatted}${
          //     variable.suffix || ''
          //   }
          //       </div>
          //     </div>`
          // );
          acc.push(
            `<div class="d-flex">
                <div>
                  ${variable.prefix || ''}${maxFormatted}${
              variable.suffix || ''
            }
                </div>
              </div>`
          );
          return acc;
        },
        responses
      );
    }
    case JOB_QUESTION_TYPES.YES_NO:
    case JOB_QUESTION_TYPES.RATING:
      return (jobQuestion.jobQuestionVariables || []).reduce(
        (acc, variable) => {
          const res = jobOfferJobQuestionResponse[variable.id];
          if (res === null || res === undefined) {
            return acc;
          } else if (jobQuestion.type === JOB_QUESTION_TYPES.RATING) {
            acc.push(parseInt(res.value));
          } else {
            acc.push(parseInt(res.value) === 1 ? 'Yes' : 'No');
          }
          return acc;
        },
        responses
      );
    default:
      return responses;
  }
};
